var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-arrow-left-hover"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-left-hover",
    clipPath: "url(#clip-arrow-left-hover)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29000",
    "data-name": "Path 29000",
    d: "M19.659,91.635l-6.181-6.181a.412.412,0,1,0-.583.583l5.478,5.478H.412a.412.412,0,1,0,0,.824H18.373L12.9,97.816a.412.412,0,1,0,.583.583l6.181-6.181A.412.412,0,0,0,19.659,91.635Z",
    transform: "translate(29.89 111.926) rotate(180)",
    fill: "#33cdd1",
    stroke: "#33cdd1",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftHover);
export default __webpack_public_path__ + "static/media/arrow-left-hover.e853dc4f829448618c31326a408f6d19.svg";
export { ForwardRef as ReactComponent };